const clienteAnotacao = (DataBase, Datatype) => {
	const ClienteAnotacao = DataBase.new(
		{
			titulo: Datatype.STRING,
			texto: Datatype.STRING,
		},
		{
			tracked: true,
			dateLogs: true,
			softDelete: true,
			collection: "cliente_anotacao",
			model: "ClienteAnotacao",
			parent: "Cliente",
		}
	);

	return ClienteAnotacao;
};

export default clienteAnotacao;
